<template>
  <div>
    <b-row class="m-auto mb-4 text-center">
      <b-col cols="2">
        <b-card class="bg-lighter">
          <div class="mb-1 text-muted">Nodes</div>
          <span class="h5">
            {{ summary.nodes }}
          </span>
          <span class="text-muted">
          </span>
        </b-card>
      </b-col>
      <b-col cols="2">
        <b-card class="bg-lighter">
          <div class="mb-1 text-muted">Total In Qps</div>
          <span class="h5">
            {{ formatDec(summary.totalInQps) }}
          </span> QPS
          <span class="text-muted">
          </span>
        </b-card>
      </b-col>
      <b-col cols="2">
        <b-card class="bg-lighter">
          <div class="mb-1 text-muted">Total Out Qps</div>
          <span class="h5">
            {{ formatDec(summary.totalOutQps) }}
          </span> QPS
          <span class="text-muted">
          </span>
        </b-card>
      </b-col>
      <b-col cols="2">
        <b-card class="bg-lighter">
          <div class="mb-1 text-muted">Avg In Qps</div>
          <span class="h5">
            {{ formatDec(summary.avgInQps) }}
          </span> QPS
          <span class="text-muted">
            Per Node
          </span>
        </b-card>
      </b-col>
      <b-col cols="2">
        <b-card class="bg-lighter">
          <div class="mb-1 text-muted">Avg Out Qps</div>
          <span class="h5">
            {{ formatDec(summary.avgOutQps) }}
          </span> QPS
          <span class="text-muted">
            Per Node
          </span>
        </b-card>
      </b-col>
      <b-col cols="2">
        <b-card class="bg-lighter">
          <div class="mb-1 text-muted">Out Throttled Qps</div>
          <span class="h5">
            {{ formatDec(summary.qpsOutThrottled) }}
          </span> QPS
          <span class="text-muted">
          </span>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import numeral from "numeral";
export default {
  name: 'ThrottleStats',
  props: {
    nodes: { required: true },
  },
  data () {
    return {
    }
  },
  methods: {
    percentOf (sm, lg) {
      return this.formatFloat((sm / lg) * 100);
    },
    formatFloat (val) {
      return this.formatNum(val, '0[.][00]a')
    },
    formatNum (val, format) {
      return numeral(Number(val).toPrecision(3)).format(format)
    },
    formatDec (val) {
      return numeral(Number(val)).format('0,0')
    },
    format (stat, val) {
      switch (stat) {
        case 'target_metric':
          switch (this.endpoint.throttle_type) {
            case 'SMART_RPM':
            case 'SMART_RPM_PRIORITY':
              return '$' + this.formatFloat(val)
            case 'SMART_FILLRATE':
            case 'SMART_FILLRATE_PRIORITY':
            case 'SMART_BIDRATE':
              return this.formatFloat(val) + '%'
            case 'SMART_BIDS':
              return val + ' bids'
            case 'PLACEMENT':
              return 'ANY BID'
            default:
              return val
          }
        case 'bid_rate':
        case 'fill_rate':
        case 'clear_rate':
          return this.formatFloat(val) + '%'
        case 'rpm':
          return '$' + this.formatFloat(val)
        case 'node_id':
          return val
        default:
          return this.formatNum(val, '0,0')
      }
    }
  },
  computed: {
    summary () {
      const sum = {
        nodes: this.nodes.length,
        avgInQps: 0,
        avgOutQps: 0,
        totalInQps: 0,
        totalOutQps: 0,
        qpsOutThrottled: 0,
      }

      let tm = 0
      for(const node of this.nodes) {
        sum.totalInQps += node.qps_in
        sum.totalOutQps += node.qps_out
        sum.qpsOutThrottled += node.qps_out_throttled
      }

      sum.avgInQps = sum.totalInQps / sum.nodes
      sum.avgOutQps = sum.totalOutQps / sum.nodes

      return sum
    }
  },
  components: {
  }
}
</script>



// WEBPACK FOOTER //
// src/admin/components/NodeSummary.vue